
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offer/[slug]",
      function () {
        return require("private-next-pages/offer/[slug]/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/offer/[slug]"])
      });
    }
  